import OrdersApi from '../api/Orders';
import * as ActionTypes from '../constants/ActionTypes';

export const createOrder = ordersCreateCommand => dispatch => {
    OrdersApi.create(ordersCreateCommand)
        .then(({data}) => {
            dispatch({
                type: ActionTypes.CREATING_ORDER,
                payload: data
            });
        });
};



// WEBPACK FOOTER //
// ./src/actions/Orders.js